import { useState } from 'react';
import {
  AccountChip,
  Cluster,
  FoldPanel,
  GiftIcon,
  HiddenFace,
  MailIcon,
  ParticipantTile,
  Menu,
  Pagination,
  ParticipantFace,
  PencilIcon,
  SantaAvatar,
  Specimens,
  Stack,
  TrashIcon,
  UserIcon,
} from '@src/components';

/** Everything that stands for a person, and the controls a list of them needs. */
export function PeopleSection() {
  const [page, setPage] = useState(3);

  return (
    <FoldPanel
      id="people"
      title="People"
      hint="Faces name a participant without a photo; the rest is what a list of participants needs around it — a participant tile, a row menu, pages."
      example={`<ParticipantFace card={card} muted={!card.isVerified} />

<Menu label="More" items={[{ id: 'rename', label: 'Rename', onSelect: rename }]} />`}
    >
      <Specimens
        label="Faces"
        note="By stored picture where there is one, otherwise by position. Muted means the card has not been opened yet."
      >
        <ParticipantFace index={0} />
        <ParticipantFace index={1} />
        <ParticipantFace index={2} />
        <ParticipantFace index={3} muted />
        <SantaAvatar />
      </Specimens>

      <Specimens label="Card size" note="For one person on their own, rather than in a list.">
        <ParticipantFace index={2} size="card" />
        <HiddenFace />
        <SantaAvatar size="card" />
      </Specimens>

      <Specimens
        label="Participant tile"
        note="Sky band, face on the seam, name, meta pill — people grid, recover, and access codes."
      >
        <Stack gap={4} align="center" wide>
          <ParticipantTile
            standalone
            avatar={<ParticipantFace index={1} size="identity" />}
            name="Nina"
            meta="Access is saved in this browser"
            metaIcon
          />
          <ParticipantTile
            standalone
            avatar={<SantaAvatar size="identity" />}
            name="Office draw 2026"
          />
        </Stack>
      </Specimens>

      <Specimens label="Row menu" note="Actions rarer than the two buttons that sit in the row.">
        <Menu
          label="More"
          items={[
            { id: 'rename', label: 'Rename', icon: <PencilIcon />, onSelect: () => {} },
            { id: 'email', label: 'Send by email', icon: <MailIcon />, onSelect: () => {} },
            { id: 'giftee', label: 'Show their giftee', icon: <GiftIcon />, onSelect: () => {} },
            {
              id: 'delete',
              label: 'Remove from the game',
              icon: <TrashIcon />,
              danger: true,
              onSelect: () => {},
            },
          ]}
        />
        <Menu
          label="Actions"
          variant="secondary"
          align="start"
          items={[
            { id: 'copy', label: 'Copy the link', onSelect: () => {} },
            { id: 'disabled', label: 'Already claimed', disabled: true, onSelect: () => {} },
          ]}
        >
          With a label
        </Menu>
      </Specimens>

      <Specimens
        label="Pagination"
        note="First and last are always reachable; the current page keeps a neighbour on each side."
      >
        <Stack wide>
          <Pagination
            page={page}
            pageCount={12}
            onChange={setPage}
            previousLabel="Previous page"
            nextLabel="Next page"
            pageLabel={(value) => `Page ${value}`}
          />
        </Stack>
      </Specimens>

      <Specimens
        label="Account chip"
        note="Header state: who is signed in, and which game the screen belongs to."
      >
        <Cluster gap={3}>
          <AccountChip icon={<UserIcon />}>Guest</AccountChip>
          <AccountChip icon={<UserIcon />} href="/login">
            nina@example.com
          </AccountChip>
          <AccountChip icon={<GiftIcon />} href="/box/abc123">
            Office draw
          </AccountChip>
        </Cluster>
      </Specimens>
    </FoldPanel>
  );
}
